import React, { useState } from "react";

// import JS files
import OrderCardDiff from "./OrderCardDiff";

const OrderCard = ({
  children,
  item,
  baseFromRing,
  adminNeedDifference,
  showTotal,
  have5Col,
  showRemainTotal,
  dontShowStoreName,
  ShowOrderCode,
}) => {
  return (
    <>
      <div className={`grid md:grid-cols-${have5Col ? 5 : 6}`}>
        {baseFromRing ? (
          <>
            <div
              className={`md:col-span-${
                have5Col ? 1 : 2
              } text-sm  mb-4 md:mb-0`}
            >
              <div>
                {dontShowStoreName ? undefined : (
                  <span className="text-myblue-100">{item.store_name}</span>
                )}
                {ShowOrderCode ? (
                  <span className="text-myblue-100">سند{item.unique_id}- </span>
                ) : undefined}
                {showRemainTotal
                  ? item.remain_total
                  : showTotal
                  ? item.total
                  : undefined}
              </div>

              <div className="mt-2">
                <OrderCardDiff
                  item={item}
                  adminNeedDifference={adminNeedDifference}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className={`md:col-span-${
                have5Col ? 1 : 2
              } text-sm  mb-4 md:mb-0`}
            >
              <div>
                <span className="text-myblue-100">{item.bangle.show_name}</span>
                /
                <span className="text-myblue-100">
                  {item.bangle.brand_name}
                </span>
                /
                <span className="bg-slate-100 rounded-lg p-1">
                  {item.bangle.gender == "girl" ? "بچه گانه" : "زنانه"}
                </span>
                /
                {item.bangle.color == "yellow" ? (
                  <span className="bg-yellow-400 rounded-lg p-1">زرد</span>
                ) : (
                  <span className="bg-slate-50 border border-slate-200 rounded-lg p-1">
                    سفید
                  </span>
                )}{" "}
                {showRemainTotal
                  ? item.remain_total
                  : showTotal
                  ? item.total
                  : undefined}
              </div>
              <div className="mt-2">
                <OrderCardDiff
                  item={item}
                  adminNeedDifference={adminNeedDifference}
                />
              </div>
            </div>
          </>
        )}

        <div className="md:col-span-4">{children}</div>
      </div>
    </>
  );
};

export default OrderCard;
